import { render, staticRenderFns } from "./ClaimEditWalletDialog.vue?vue&type=template&id=f467fe70&"
import script from "./ClaimEditWalletDialog.vue?vue&type=script&lang=js&"
export * from "./ClaimEditWalletDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports